const styles = {
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    padding: '10px'
  },
  contactImage: {
    width: 20,
    height: 20,
    alignSelf: 'center',
    resizeMode: 'contain'
  }
};

export default styles;
